function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M136.5 185.1l116 117.8c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L128 224.7 27.6 326.9c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17l116-117.8c4.7-4.6 12.3-4.6 17 .1z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-prefix": "fal",
    "data-icon": "angle-up",
    viewBox: "0 0 256 512",
    className: "svg-inline--fa fa-angle-up fa-w-8 fa-3x"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/arrowUp.49b9e261.svg";
export { SvgComponent as ReactComponent };